import React, { useEffect, useMemo, useState } from "react";
import {
  getSponsoredCampaignByPlacement,
  trackSponsoredCampaignClick,
  trackSponsoredCampaignImpression,
} from "../../utils/sponsoredCampaignsApi";
import "./SponsoredSlot.css";

const DEFAULT_DISMISS_TTL_HOURS = 3;

function SponsoredSlot({ placement, className = "" }) {
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadCampaign = async () => {
      const nextCampaign = await getSponsoredCampaignByPlacement(placement);
      if (!isMounted) return;
      setCampaign(nextCampaign);
    };

    loadCampaign();
    return () => {
      isMounted = false;
    };
  }, [placement]);

  const storageKey = useMemo(
    () => `sponsored_dismiss_until_${placement}_${campaign?.id || "none"}`,
    [placement, campaign?.id]
  );
  const [dismissedUntil, setDismissedUntil] = useState(() => {
    try {
      return Number(localStorage.getItem(storageKey) || "0");
    } catch (error) {
      return 0;
    }
  });

  useEffect(() => {
    try {
      setDismissedUntil(Number(localStorage.getItem(storageKey) || "0"));
    } catch (error) {
      setDismissedUntil(0);
    }
  }, [storageKey]);

  useEffect(() => {
    if (!campaign) return;
    trackSponsoredCampaignImpression(campaign.id, { placement });
  }, [campaign, placement]);

  const isDismissed = dismissedUntil > Date.now();

  if (!campaign) return null;
  if (isDismissed) return null;

  const onCtaClick = () => {
    trackSponsoredCampaignClick(campaign.id, { placement });
  };

  const onDismiss = () => {
    const ttlHours =
      typeof campaign.dismissTtlHours === "number" && campaign.dismissTtlHours > 0
        ? campaign.dismissTtlHours
        : DEFAULT_DISMISS_TTL_HOURS;
    const until = Date.now() + ttlHours * 60 * 60 * 1000;
    setDismissedUntil(until);
    try {
      localStorage.setItem(storageKey, String(until));
    } catch (error) {
      // Ignore storage errors and just close for current view.
    }
  };

  return (
    <section className={`sponsored-slot ${className}`}>
      <button
        type="button"
        className="sponsored-slot-close"
        onClick={onDismiss}
      >
        Затвори
      </button>
      <div className="sponsored-slot-media">
        <img src={campaign.imageUrl} alt={campaign.title} loading="lazy" />
      </div>
      <div className="sponsored-slot-content">
        <p className="sponsored-slot-label">Спонзорирано</p>
        <h3>{campaign.title}</h3>
        <p>{campaign.description}</p>
        <a
          href={campaign.ctaUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onCtaClick}
          className="sponsored-slot-cta"
        >
          {campaign.ctaText}
        </a>
      </div>
    </section>
  );
}

export default SponsoredSlot;
